import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom/client';
import { getOrCreateVisitorId } from '@/lib/conversation-storage';
import { getAppConfig } from '@/lib/env';
import { initTracker } from '@/lib/tracker';
import globalCss from '@/styles/globals.css';
import EmbedFixedAgentClient from './agent-client';
const scriptTag = document.querySelector('script[data-lk-sandbox-id]');
const sandboxIdAttribute = scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkSandboxId;
const webWidgetIdAttribute = scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkWebWidgetId;
// Customizable CSS properties from data attributes
const buttonColor = (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkButtonColor) || '#7C3AED';
const bottomMargin = (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkBottomMargin) || '16';
const rightMargin = (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkRightMargin) || '16';
// Email collection config from data attribute
const collectEmail = (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkCollectEmail) === 'true';
// Branding overrides from data attributes
const chatName = scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkChatName;
const avatarUrl = scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkAvatarUrl;
// Lead scoring tracker (enabled by default, opt-out via data-lk-tracking="false")
const enableTracking = (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkTracking) !== 'false';
// Teaser & quick action config from data attributes
const typingDuration = (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkTypingDuration)
    ? Number(scriptTag.dataset.lkTypingDuration)
    : undefined;
let teaserMessages;
try {
    const raw = scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkTeaserMessages;
    if (raw)
        teaserMessages = JSON.parse(raw);
}
catch (_a) {
    console.warn('DATALYA popup embed - invalid data-lk-teaser-messages JSON');
}
let quickActions;
try {
    const raw = scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.dataset.lkQuickActions;
    if (raw)
        quickActions = JSON.parse(raw);
}
catch (_b) {
    console.warn('DATALYA popup embed - invalid data-lk-quick-actions JSON');
}
if (sandboxIdAttribute) {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('id', 'lk-embed-wrapper');
    document.body.appendChild(wrapper);
    // Use a shadow root so that any relevant css classes don't leak out and effect the broader page
    const shadowRoot = wrapper.attachShadow({ mode: 'open' });
    // Include all app styles into the shadow root
    // FIXME: this includes styles for the welcome page / etc, not just the popup embed!
    const styleTag = document.createElement('style');
    // Add custom CSS properties for brand customization
    const customProperties = `
    :host {
      --lk-button-color: ${buttonColor};
      --lk-bottom-margin: ${bottomMargin}px;
      --lk-right-margin: ${rightMargin}px;
    }
  `;
    styleTag.textContent = customProperties + globalCss;
    shadowRoot.appendChild(styleTag);
    const reactRoot = document.createElement('div');
    shadowRoot.appendChild(reactRoot);
    getAppConfig(window.location.origin, sandboxIdAttribute, webWidgetIdAttribute)
        .then((appConfig) => {
        // Merge data-* attribute overrides into appConfig
        if (teaserMessages)
            appConfig.teaserMessages = teaserMessages;
        if (typingDuration !== undefined)
            appConfig.typingDuration = typingDuration;
        if (quickActions)
            appConfig.quickActions = quickActions;
        if (collectEmail)
            appConfig.collectEmail = true;
        if (chatName)
            appConfig.chatName = chatName;
        if (avatarUrl)
            appConfig.avatarUrl = avatarUrl;
        appConfig.enableTracking = enableTracking;
        // Initialize visitor behaviour tracker for lead scoring
        if (enableTracking && appConfig.webWidgetId) {
            // Derive events endpoint from the script tag's src URL (always points to our server)
            let eventsEndpoint = '/api/events';
            if (scriptTag === null || scriptTag === void 0 ? void 0 : scriptTag.src) {
                try {
                    const scriptOrigin = new URL(scriptTag.src).origin;
                    eventsEndpoint = `${scriptOrigin}/api/events`;
                }
                catch (_a) {
                    // Fallback to relative path
                }
            }
            initTracker({
                widgetId: appConfig.webWidgetId,
                visitorId: getOrCreateVisitorId(),
                endpoint: eventsEndpoint,
            });
        }
        const root = ReactDOM.createRoot(reactRoot);
        root.render(_jsx(EmbedFixedAgentClient, { appConfig: appConfig }));
    })
        .catch((err) => {
        console.error('DATALYA popup embed error - Error loading app config:', err);
    });
}
else {
    console.error('DATALYA popup embed error - no data-lk-sandbox-id attribute found on script tag. This is required!');
}
